import { styled } from "common/components";

export const StyledStatusContainer = styled("section")(({ theme }) => ({
  display: "grid",
  rowGap: theme.spacing(0.4),
  justifyItems: "center",
}));
